export default "__VITE_ASSET__C90EREqU__"